<script setup>
import { computed } from 'vue'

const props = defineProps({
  showMenu: {},
  addButton: { default: true, required: false },
  deleteButton: { default: true, required: false },
  title: { default: "Soil Profile", required: false },
  iconBefore: {
    default: "mdi-chevron-left",
    required: false
  },
  iconAfter: {
    default: "mdi-chevron-right",
    required: false
  },
  x: {},
  y: {}
})

const emit = defineEmits(['addBefore', 'addAfter', 'action', 'update:showMenu'])

const show = computed({
  get () {
    return props.showMenu
  },
  set (value) {
    emit("update:showMenu", value)
  }
})
</script>

<template>
  <v-menu
    v-model="show"
    :target="[x, y]"
    location="right"
  >
    <v-list>
      <v-list-item density="compact">
        <v-list-item-title>{{ title }}</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="addButton" density="compact" @click="emit('addBefore')">
        <v-icon :icon="iconBefore" class="mr-2"></v-icon>
        <v-list-item-title>Add Before</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="addButton" dense @click="emit('addAfter')">
        <v-icon :icon="iconAfter" class="mr-2"></v-icon>
        <v-list-item-title>Add After</v-list-item-title>
      </v-list-item>
      <v-list-item v-if="deleteButton" dense @click="emit('action')">
        <v-icon icon="mdi-delete" class="mr-2"></v-icon>
        <v-list-item-title>Delete</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<style scoped>
  :deep(.v-list-item__content) {
    display: flex;
  }
</style>
